import React from 'react';
import { Card, Input, Button, Table, Modal, Form, DatePicker, Spin, Divider,
	message, Tag, Tooltip, Typography, Pagination, Checkbox, Switch, Alert,
} from 'antd';
import {
	SearchOutlined, PlusOutlined, CloseSquareOutlined,
	ExclamationCircleOutlined, DiffOutlined, RedoOutlined, KeyOutlined,
	SaveOutlined, CloseCircleOutlined, CopyOutlined, WarningOutlined,
	CheckCircleOutlined, PlusCircleOutlined, SyncOutlined, FormOutlined,
	EditOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title : 'Manajemen API Key',
	apiUrl: {
		data  : 'transaksi/api/apikey/',
		scopes: 'transaksi/api/apikey/scopes/',
	},
	breadCrumb: [
		<span><DiffOutlined /> Pengaturan</span>,
		'API Key',
	],
};

const config = new Config();

class DataApiKey extends React.Component {
	formModalRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errMsg    : '',
			errTitle  : '',
			loadingData: false,
			pagination: { pageSize: 25, current: 1, total: 0 },
			searchText: '',
			dataSource: [],
			isMobile  : window.innerWidth <= 768,
			scopeOptions: [],

			// modal tambah/edit
			modalVisible      : false,
			modalMode         : 'tambah', // 'tambah' | 'edit'
			modalEditId       : null,
			modalEditData     : null,
			modalLoadingSubmit: false,

			// modal "tampilkan sekali" setelah create sukses
			newKeyModalVisible: false,
			newKeyNamaAplikasi: '',
			newKeyValue       : '',
		};
		this._searchTimer = null;
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this.getData();
		this.getScopes();
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
		clearTimeout(this._searchTimer);
	}

	// ── Data list ───────────────────────────────────────────
	async getData(limit = this.state.pagination.pageSize, offset = 0, search = this.state.searchText) {
		this.setState({ loadingData: true });
		const url = configClass.apiUrl.data + '?limit=' + limit + '&offset=' + offset + '&search=' + search;
		this.props.ajaxViewHandler('get', url)
			.then(() => {
				if (this.props.isSuccess) {
					const data = this.props.responseMsg;
					this.setState(prev => ({
						dataSource: data.results,
						pagination: { ...prev.pagination, total: data.count },
					}));
				} else {
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
				this.setState({ loadingData: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data', duration: 2, key: 'toast' });
				this.setState({ loadingData: false });
			});
	}

	async getScopes() {
		this.props.ajaxViewHandler('get', configClass.apiUrl.scopes)
			.then(() => {
				if (this.props.isSuccess) {
					this.setState({ scopeOptions: this.props.responseMsg });
				}
			})
			.catch(() => {});
	}

	handleSearchChange = (e) => {
		const val = e.target.value;
		this.setState({ searchText: val });
		clearTimeout(this._searchTimer);
		this._searchTimer = setTimeout(() => {
			this.setState(prev => ({ pagination: { ...prev.pagination, current: 1 } }));
			this.getData(this.state.pagination.pageSize, 0, val);
		}, 400);
	}

	handleTableChange = (pagination) => {
		this.setState({ pagination: { ...this.state.pagination, pageSize: pagination.pageSize, current: pagination.current } });
		this.getData(pagination.pageSize, (pagination.current - 1) * pagination.pageSize, this.state.searchText);
	}

	handleMobilePageChange = (page, pageSize) => {
		this.setState(prev => ({ pagination: { ...prev.pagination, current: page, pageSize } }));
		this.getData(pageSize, (page - 1) * pageSize, this.state.searchText);
	}

	// ── Toggle aktif/nonaktif ────────────────────────────────
	handleToggleActive(row) {
		this.props.ajaxHandler('patch', configClass.apiUrl.data + row.id + '/', { is_active: !row.is_active }, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: row.is_active ? 'Key dinonaktifkan' : 'Key diaktifkan', duration: 2, key: 'toast' });
					this.getData(this.state.pagination.pageSize, (this.state.pagination.current - 1) * this.state.pagination.pageSize, this.state.searchText);
				} else {
					message.error({ content: 'Gagal mengubah status', duration: 2, key: 'toast' });
				}
			})
			.catch(() => message.error({ content: 'Kesalahan jaringan', duration: 2, key: 'toast' }));
	}

	// ── Revoke & Generate Ulang ──────────────────────────────
	showRegenerateConfirm(row) {
		Modal.confirm({
			title  : 'Revoke & Generate Ulang?',
			icon   : <ExclamationCircleOutlined />,
			content: `Key lama milik "${row.nama_aplikasi}" akan LANGSUNG tidak berlaku begitu ini diproses - aplikasi pihak ketiga yang masih memakai key lama akan gagal autentikasi seketika. Nama aplikasi dan scope tidak berubah, cuma key-nya yang diganti baru.`,
			okText : 'Ya, Revoke & Generate Ulang',
			okType : 'danger',
			cancelText: 'Batal',
			onOk: () => this.prosesRegenerate(row),
		});
	}

	prosesRegenerate(row) {
		message.loading({ content: 'Memproses...', key: 'toast' });
		this.props.ajaxHandler('post', configClass.apiUrl.data + row.id + '/regenerate/', {}, false, true)
			.then(() => {
				if (this.props.isSuccess) {
					message.destroy();
					const data = this.props.responseMsg;
					this.setState({
						newKeyModalVisible: true,
						newKeyNamaAplikasi: data.nama_aplikasi,
						newKeyValue       : data.api_key,
					});
					this.getData(this.state.pagination.pageSize, (this.state.pagination.current - 1) * this.state.pagination.pageSize, this.state.searchText);
				} else {
					message.destroy();
					this.setState({ errTitle: 'Gagal generate ulang', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => {
				message.error({ content: 'Kesalahan jaringan', duration: 2, key: 'toast' });
			});
	}

	// ── Hapus ───────────────────────────────────────────────
	showDeleteConfirm(id, nama) {
		Modal.confirm({
			title  : 'Konfirmasi Hapus',
			icon   : <ExclamationCircleOutlined />,
			content: `Yakin ingin menghapus API Key "${nama}"? Aplikasi pihak ketiga yang masih memakai key ini akan langsung kehilangan akses.`,
			okText : 'Hapus',
			okType : 'danger',
			cancelText: 'Batal',
			onOk: () => this.prosesHapus(id),
		});
	}

	prosesHapus(id) {
		message.loading({ content: 'Menghapus...', key: 'toast' });
		this.props.ajaxHandler('delete', configClass.apiUrl.data + id + '/')
			.then(() => {
				if (this.props.isSuccess) {
					message.success({ content: 'API Key berhasil dihapus', duration: 2, key: 'toast' });
					this.getData();
				} else {
					message.error({ content: 'Gagal menghapus data', duration: 2, key: 'toast' });
					this.setState({ errTitle: 'Gagal hapus', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => message.error({ content: 'Kesalahan jaringan', duration: 2, key: 'toast' }));
	}

	// ── Modal tambah/edit ────────────────────────────────────
	openAddModal = () => {
		this.setState({ modalVisible: true, modalMode: 'tambah', modalEditId: null, modalEditData: null });
		if (this.formModalRef.current) this.formModalRef.current.resetFields();
	}

	openEditModal = (row) => {
		// Data baris tabel sudah lengkap (nama_aplikasi/scopes/expires_at) -
		// tidak perlu GET ulang ke server. Disimpan ke modalEditData dan
		// dipakai sebagai `initialValues` <Form> (lihat formBody di
		// renderModal) - BUKAN via setFieldsValue imperatif, karena Modal
		// pakai destroyOnClose (Form selalu di-mount ulang dari nol tiap
		// buka) sehingga tidak ada hook "after open" yang bisa diandalkan
		// utk timing setFieldsValue (Modal antd cuma py `afterClose`, dipicu
		// pas tutup, BUKAN pas buka - gotcha yang sempat bikin fix pertama
		// gagal). initialValues dievaluasi persis saat Form mount, jadi
		// tidak ada race sama sekali.
		this.setState({
			modalVisible: true,
			modalMode   : 'edit',
			modalEditId : row.id,
			modalEditData: {
				nama_aplikasi: row.nama_aplikasi,
				scopes       : row.scopes || [],
				expires_at   : row.expires_at ? moment(row.expires_at) : null,
			},
		});
	}

	closeModal = () => {
		if (this.state.modalLoadingSubmit) return;
		this.setState({ modalVisible: false, modalEditId: null, modalEditData: null });
		if (this.formModalRef.current) this.formModalRef.current.resetFields();
	}

	handleModalSubmit = (values) => {
		const { modalMode, modalEditId } = this.state;
		const payload = {
			nama_aplikasi: values.nama_aplikasi,
			scopes       : values.scopes || [],
			expires_at   : values.expires_at ? values.expires_at.format('YYYY-MM-DDTHH:mm:ss') : null,
		};
		const isEdit = modalMode === 'edit';
		const method = isEdit ? 'patch' : 'post';
		const url    = isEdit ? configClass.apiUrl.data + modalEditId + '/' : configClass.apiUrl.data;

		this.setState({ modalLoadingSubmit: true });
		message.loading({ content: isEdit ? 'Menyimpan perubahan...' : 'Membuat API Key...', key: 'toast' });

		this.props.ajaxHandler(method, url, payload, false, true)
			.then(() => {
				this.setState({ modalLoadingSubmit: false });
				if (this.props.isSuccess) {
					if (isEdit) {
						message.success({ content: 'Perubahan berhasil disimpan', duration: 2, key: 'toast' });
						this.setState({ modalVisible: false, modalEditId: null });
						if (this.formModalRef.current) this.formModalRef.current.resetFields();
					} else {
						message.destroy();
						const data = this.props.responseMsg;
						this.setState({
							modalVisible      : false,
							newKeyModalVisible: true,
							newKeyNamaAplikasi: data.nama_aplikasi,
							newKeyValue       : data.api_key,
						});
						if (this.formModalRef.current) this.formModalRef.current.resetFields();
					}
					this.getData(this.state.pagination.pageSize, (this.state.pagination.current - 1) * this.state.pagination.pageSize, this.state.searchText);
				} else {
					message.destroy();
					this.setState({ errTitle: isEdit ? 'Gagal menyimpan perubahan' : 'Gagal membuat API Key', errMsg: this.props.responseMsg });
				}
			})
			.catch(() => {
				this.setState({ modalLoadingSubmit: false });
				message.error({ content: 'Kesalahan jaringan', duration: 2, key: 'toast' });
			});
	}

	closeNewKeyModal = () => {
		this.setState({ newKeyModalVisible: false, newKeyNamaAplikasi: '', newKeyValue: '' });
	}

	copyToClipboard(value) {
		// navigator.clipboard cuma tersedia di "secure context" (HTTPS atau
		// localhost) - panel ini sering diakses via IP lokal lewat HTTP biasa
		// (lihat CORS_ALLOWED_ORIGINS di .env.docker: 192.168.168.167/170),
		// jadi navigator.clipboard bisa undefined di sana. Fallback ke
		// execCommand('copy') lewat textarea sementara supaya tetap jalan
		// di kondisi non-secure context itu.
		if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
			navigator.clipboard.writeText(value).then(() => {
				message.success({ content: 'Tersalin ke clipboard', duration: 1.5, key: 'copy' });
			}).catch(() => {
				this.copyToClipboardFallback(value);
			});
		} else {
			this.copyToClipboardFallback(value);
		}
	}

	copyToClipboardFallback(value) {
		const textarea = document.createElement('textarea');
		textarea.value = value;
		// Hindari layout shift/scroll-jump - taruh di luar viewport, bukan display:none
		// (execCommand('copy') butuh elemen ter-render/selectable, display:none gagal disalin).
		textarea.style.position = 'fixed';
		textarea.style.left = '-9999px';
		textarea.style.top = '0';
		document.body.appendChild(textarea);
		textarea.focus();
		textarea.select();
		try {
			const success = document.execCommand('copy');
			if (success) {
				message.success({ content: 'Tersalin ke clipboard', duration: 1.5, key: 'copy' });
			} else {
				message.error({ content: 'Gagal menyalin otomatis - silakan blok teks lalu salin manual (Ctrl+C)', duration: 3, key: 'copy' });
			}
		} catch (e) {
			message.error({ content: 'Gagal menyalin otomatis - silakan blok teks lalu salin manual (Ctrl+C)', duration: 3, key: 'copy' });
		}
		document.body.removeChild(textarea);
	}

	scopeLabel(value) {
		const found = this.state.scopeOptions.find(s => s.value === value);
		return found ? found.label : value;
	}

	// ── Render modal tambah/edit ──────────────────────────────
	renderModal() {
		const { modalVisible, modalMode, modalLoadingSubmit, isMobile, scopeOptions } = this.state;
		const isEdit = modalMode === 'edit';

		const header = (
			<div style={{
				background  : 'linear-gradient(135deg, #0f2847 0%, #1e4d8a 60%, #0a3d6b 100%)',
				borderRadius: isMobile ? 0 : '8px 8px 0 0',
				padding     : isMobile ? '14px 18px' : '20px 28px',
				display     : 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 14,
			}}>
				<div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
					<div style={{
						width: isMobile ? 36 : 44, height: isMobile ? 36 : 44, flexShrink: 0,
						borderRadius: 10, background: 'rgba(255,255,255,0.15)',
						display: 'flex', alignItems: 'center', justifyContent: 'center',
					}}>
						{isEdit
							? <EditOutlined style={{ color: '#fff', fontSize: isMobile ? 16 : 20 }} />
							: <PlusCircleOutlined style={{ color: '#fff', fontSize: isMobile ? 16 : 20 }} />
						}
					</div>
					<div>
						<div style={{ color: '#fff', fontWeight: 700, fontSize: isMobile ? 14 : 16 }}>
							{isEdit ? 'Edit API Key' : 'Buat API Key Baru'}
						</div>
						{!isMobile && (
							<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 12, marginTop: 2 }}>
								{isEdit ? 'Key (X-API-Key) tidak berubah - cuma nama/scope/kadaluarsa' : 'Untuk integrasi aplikasi pihak ketiga'}
							</div>
						)}
					</div>
				</div>
				<Button
					type="text"
					icon={<CloseCircleOutlined style={{ fontSize: 18 }} />}
					onClick={this.closeModal}
					disabled={modalLoadingSubmit}
					style={{ color: 'rgba(255,255,255,0.8)', padding: 4 }}
				/>
			</div>
		);

		const formBody = (
			<div style={{ padding: isMobile ? '18px 16px 0' : '24px 28px 0' }}>
				<Form
					ref={this.formModalRef}
					layout="vertical"
					onFinish={this.handleModalSubmit}
					initialValues={isEdit && this.state.modalEditData ? this.state.modalEditData : {}}
				>
					<Form.Item
						label="Nama Aplikasi"
						name="nama_aplikasi"
						rules={[{ required: true, message: 'Nama aplikasi harus diisi' }]}
					>
						<Input
							placeholder="Contoh: SIGNAL Korlantas, EDC Bank Kalteng, dst..."
							style={{ borderRadius: 8, height: 38 }}
						/>
					</Form.Item>

					<Form.Item
						label="Scope (endpoint yang boleh diakses)"
						name="scopes"
						rules={[{ required: true, message: 'Pilih minimal satu scope' }]}
					>
						<Checkbox.Group style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
							{scopeOptions.map(s => (
								<Checkbox key={s.value} value={s.value}>{s.label}</Checkbox>
							))}
						</Checkbox.Group>
					</Form.Item>

					<Form.Item
						label="Kadaluarsa (opsional)"
						name="expires_at"
						style={{ marginBottom: 0 }}
					>
						<DatePicker
							showTime
							format="DD-MM-YYYY HH:mm"
							placeholder="Tidak ada kadaluarsa"
							style={{ width: '100%', borderRadius: 8 }}
							allowClear
						/>
					</Form.Item>
				</Form>
			</div>
		);

		const footer = (
			<div>
				<Divider style={{ margin: '16px 0 0' }} />
				<div style={{
					padding       : isMobile ? '14px 16px' : '16px 28px',
					display       : 'flex',
					flexDirection : isMobile ? 'column-reverse' : 'row',
					justifyContent: isMobile ? 'stretch' : 'flex-end',
					gap           : 10,
					background    : '#fafafa',
					borderRadius  : isMobile ? 0 : '0 0 8px 8px',
				}}>
					<Button
						icon={<CloseCircleOutlined />}
						onClick={this.closeModal}
						disabled={modalLoadingSubmit}
						style={{ borderRadius: 8, height: 40, width: isMobile ? '100%' : 'auto' }}
					>
						Batal
					</Button>
					<Button
						type="primary"
						icon={<SaveOutlined />}
						loading={modalLoadingSubmit}
						onClick={() => this.formModalRef.current && this.formModalRef.current.submit()}
						style={{
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							border: 'none', borderRadius: 8, fontWeight: 600,
							height: 40, width: isMobile ? '100%' : 'auto',
						}}
					>
						{isEdit ? 'Simpan Perubahan' : 'Buat API Key'}
					</Button>
				</div>
			</div>
		);

		return (
			<Modal
				visible={modalVisible}
				onCancel={this.closeModal}
				footer={null}
				title={null}
				closable={false}
				width={isMobile ? 'calc(100vw - 16px)' : 520}
				style={isMobile ? { top: 12, margin: '0 8px' } : { top: 60 }}
				bodyStyle={{ padding: 0 }}
				maskClosable={!modalLoadingSubmit}
				destroyOnClose
			>
				{header}
				{formBody}
				{footer}
			</Modal>
		);
	}

	// ── Render modal "tampilkan sekali" ──────────────────────
	renderNewKeyModal() {
		const { newKeyModalVisible, newKeyNamaAplikasi, newKeyValue, isMobile } = this.state;

		return (
			<Modal
				visible={newKeyModalVisible}
				onCancel={this.closeNewKeyModal}
				footer={null}
				title={null}
				closable={false}
				width={isMobile ? 'calc(100vw - 16px)' : 560}
				style={isMobile ? { top: 12, margin: '0 8px' } : { top: 80 }}
				bodyStyle={{ padding: 0 }}
				maskClosable={false}
			>
				<div style={{
					background  : 'linear-gradient(135deg, #15803d 0%, #16a34a 100%)',
					borderRadius: isMobile ? 0 : '8px 8px 0 0',
					padding     : isMobile ? '14px 18px' : '20px 28px',
					display     : 'flex', alignItems: 'center', gap: 14,
				}}>
					<div style={{
						width: isMobile ? 36 : 44, height: isMobile ? 36 : 44, flexShrink: 0,
						borderRadius: 10, background: 'rgba(255,255,255,0.2)',
						display: 'flex', alignItems: 'center', justifyContent: 'center',
					}}>
						<CheckCircleOutlined style={{ color: '#fff', fontSize: isMobile ? 16 : 20 }} />
					</div>
					<div>
						<div style={{ color: '#fff', fontWeight: 700, fontSize: isMobile ? 14 : 16 }}>
							API Key Berhasil Dibuat
						</div>
						<div style={{ color: 'rgba(255,255,255,0.8)', fontSize: 12, marginTop: 2 }}>
							{newKeyNamaAplikasi}
						</div>
					</div>
				</div>

				<div style={{ padding: isMobile ? '18px 16px' : '24px 28px' }}>
					<Alert
						type="warning"
						showIcon
						icon={<WarningOutlined />}
						message="Salin sekarang - key ini tidak akan ditampilkan lagi setelah modal ini ditutup."
						style={{ marginBottom: 16, borderRadius: 8 }}
					/>

					<Text style={{ fontSize: 12, color: '#666', fontWeight: 600 }}>NILAI HEADER X-API-Key</Text>
					<div style={{
						marginTop: 6,
						background: '#0f2847', borderRadius: 8, padding: '12px 14px',
						display: 'flex', alignItems: 'center', gap: 10,
					}}>
						<Text
							copyable={false}
							style={{
								color: '#7ee787', fontFamily: 'monospace', fontSize: 13,
								wordBreak: 'break-all', flex: 1,
							}}
						>
							{newKeyValue}
						</Text>
						<Button
							icon={<CopyOutlined />}
							size="small"
							onClick={() => this.copyToClipboard(newKeyValue)}
							style={{ flexShrink: 0 }}
						>
							Salin
						</Button>
					</div>
				</div>

				<Divider style={{ margin: 0 }} />
				<div style={{
					padding    : isMobile ? '14px 16px' : '16px 28px',
					display    : 'flex', justifyContent: 'flex-end',
					background : '#fafafa',
					borderRadius: isMobile ? 0 : '0 0 8px 8px',
				}}>
					<Button
						type="primary"
						onClick={this.closeNewKeyModal}
						style={{
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							border: 'none', borderRadius: 8, fontWeight: 600, height: 40,
							width: isMobile ? '100%' : 'auto',
						}}
					>
						Saya Sudah Menyalin, Tutup
					</Button>
				</div>
			</Modal>
		);
	}

	// ── Table columns ────────────────────────────────────────
	_buildColumns() {
		return [
			{
				title : 'No',
				key   : 'no',
				width : 56,
				align : 'center',
				render: (_, __, index) => {
					const { pagination } = this.state;
					return <Text style={{ fontSize: 12, color: '#888' }}>{(pagination.current - 1) * pagination.pageSize + index + 1}</Text>;
				},
			},
			{
				title : 'Nama Aplikasi',
				dataIndex: 'nama_aplikasi',
				key   : 'nama_aplikasi',
				render: (val, row) => (
					<div>
						<Text strong>{val}</Text>
						<div style={{ fontSize: 11, color: '#999', fontFamily: 'monospace', marginTop: 2 }}>
							{row.key_id}
						</div>
					</div>
				),
			},
			{
				title : 'Scope',
				dataIndex: 'scopes',
				key   : 'scopes',
				render: (scopes) => (
					<div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
						{(scopes || []).map(s => (
							<Tag key={s} color="blue" style={{ fontSize: 11 }}>{this.scopeLabel(s)}</Tag>
						))}
					</div>
				),
			},
			{
				title : 'Status',
				dataIndex: 'is_active',
				key   : 'is_active',
				width : 100,
				align : 'center',
				render: (val, row) => (
					<Switch
						size="small"
						checked={val}
						onChange={() => this.handleToggleActive(row)}
						checkedChildren="Aktif"
						unCheckedChildren="Nonaktif"
					/>
				),
			},
			{
				title : 'Terakhir Dipakai',
				dataIndex: 'last_used_at',
				key   : 'last_used_at',
				width : 150,
				render: (val) => val
					? <Text style={{ fontSize: 12 }}>{moment(val).format('DD-MM-YYYY HH:mm')}</Text>
					: <Text type="secondary" style={{ fontSize: 12 }}>Belum pernah</Text>,
			},
			{
				title : 'Aksi',
				key   : 'aksi',
				width : 170,
				fixed : 'right',
				align : 'center',
				render: (_, row) => (
					<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
						<Tooltip title="Edit Nama/Scope/Kadaluarsa">
							<Button size="small" shape="circle" type="primary" ghost onClick={() => this.openEditModal(row)}>
								<FormOutlined />
							</Button>
						</Tooltip>
						<Tooltip title="Revoke & Generate Ulang">
							<Button size="small" shape="circle" onClick={() => this.showRegenerateConfirm(row)}>
								<SyncOutlined />
							</Button>
						</Tooltip>
						<Tooltip title="Hapus">
							<Button size="small" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id, row.nama_aplikasi)}>
								<CloseSquareOutlined />
							</Button>
						</Tooltip>
					</div>
				),
			},
		];
	}

	// ── Mobile card ──────────────────────────────────────────
	renderMobileCard(row) {
		return (
			<Card
				key={row.id}
				style={{ borderRadius: 14, marginBottom: 12, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: '1px solid #f0f0f0', overflow: 'hidden' }}
				bodyStyle={{ padding: 14 }}
			>
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10 }}>
					<div style={{ flex: 1, minWidth: 0 }}>
						<div style={{ fontWeight: 700, fontSize: 15, color: '#0f2847' }}>{row.nama_aplikasi}</div>
						<div style={{ fontSize: 11, color: '#999', fontFamily: 'monospace', marginTop: 2 }}>{row.key_id}</div>
					</div>
					<Switch
						size="small"
						checked={row.is_active}
						onChange={() => this.handleToggleActive(row)}
						checkedChildren="Aktif"
						unCheckedChildren="Nonaktif"
					/>
				</div>
				<div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginTop: 8 }}>
					{(row.scopes || []).map(s => (
						<Tag key={s} color="blue" style={{ fontSize: 11 }}>{this.scopeLabel(s)}</Tag>
					))}
				</div>
				<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 10 }}>
					<Text type="secondary" style={{ fontSize: 12 }}>
						{row.last_used_at ? `Dipakai ${moment(row.last_used_at).format('DD-MM-YYYY HH:mm')}` : 'Belum pernah dipakai'}
					</Text>
					<div style={{ display: 'flex', gap: 6 }}>
						<Button size="small" shape="circle" type="primary" ghost onClick={() => this.openEditModal(row)}>
							<FormOutlined />
						</Button>
						<Button size="small" shape="circle" onClick={() => this.showRegenerateConfirm(row)}>
							<SyncOutlined />
						</Button>
						<Button size="small" shape="circle" danger onClick={() => this.showDeleteConfirm(row.id, row.nama_aplikasi)}>
							<CloseSquareOutlined />
						</Button>
					</div>
				</div>
			</Card>
		);
	}

	// ── Main render ──────────────────────────────────────────
	render() {
		const { errMsg, errTitle, loadingData, dataSource, pagination, isMobile, searchText } = this.state;

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.apikey-wrap .ant-table-thead > tr > th {
							background: linear-gradient(135deg, #0f284711, #1e4d8a11) !important;
							font-weight: 700; font-size: 13px; color: #0f2847;
							border-bottom: 2px solid #d0dff5;
						}
						.apikey-wrap .ant-table-tbody > tr > td { padding: 12px 16px; vertical-align: middle; }
						.apikey-wrap .ant-table-tbody > tr:hover > td { background: #e8f0fb !important; }
						.apikey-wrap .ant-table-tbody > tr:nth-child(even) > td { background: #fafafa; }
						.apikey-wrap .ant-table-tbody > tr:nth-child(even):hover > td { background: #e8f0fb !important; }
						.apikey-wrap .ant-form-item-label > label { font-weight: 600; color: #374151; font-size: 13px; }
					`}</style>
				</Helmet>

				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				{this.renderModal()}
				{this.renderNewKeyModal()}

				<Card
					className="apikey-wrap"
					style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
					bodyStyle={{ padding: 0 }}
				>
					{/* Header */}
					<div style={{
						padding       : isMobile ? '14px 16px' : '16px 20px',
						background    : 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display       : 'flex', alignItems: 'center',
						justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div>
							<div style={{ color: '#fff', fontWeight: 700, fontSize: isMobile ? 14 : 17 }}>
								<KeyOutlined style={{ marginRight: 8 }} />{configClass.title}
							</div>
							{!isMobile && (
								<div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 12, marginTop: 2 }}>
									Total {pagination.total || 0} API Key terdaftar{loadingData && ' · Memuat...'}
								</div>
							)}
						</div>
						<div style={{ display: 'flex', gap: 8 }}>
							<Tooltip title="Refresh">
								<Button
									onClick={() => this.setState(
										prev => ({ searchText: '', pagination: { ...prev.pagination, current: 1 } }),
										() => this.getData(this.state.pagination.pageSize, 0, '')
									)}
									icon={<RedoOutlined />}
									style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								>
									{!isMobile && 'Refresh'}
								</Button>
							</Tooltip>
							<Button
								type="primary"
								icon={<PlusOutlined />}
								onClick={this.openAddModal}
								style={{ borderRadius: 8, background: '#fff', color: '#0f2847', border: 'none', fontWeight: 600 }}
							>
								{isMobile ? 'Buat' : 'Buat API Key'}
							</Button>
						</div>
					</div>

					{/* Search bar */}
					<div style={{
						padding     : isMobile ? '10px 12px' : '12px 20px',
						borderBottom: '1px solid #f0f0f0', background: '#fff',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap',
					}}>
						<Text type="secondary" style={{ fontSize: 12 }}>
							{loadingData ? 'Memuat data...' : `Menampilkan ${dataSource.length} dari ${pagination.total || 0} data`}
						</Text>
						<Input
							placeholder="Cari nama aplikasi atau key id..."
							allowClear
							prefix={<SearchOutlined style={{ color: '#bbb' }} />}
							style={{ borderRadius: 8, maxWidth: isMobile ? '100%' : 340, width: isMobile ? '100%' : 'auto' }}
							value={searchText}
							onChange={this.handleSearchChange}
						/>
					</div>

					{/* Konten */}
					<div style={{ padding: isMobile ? 12 : 0 }}>
						{isMobile ? (
							<div>
								{loadingData
									? <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Memuat data...</div>
									: dataSource.length === 0
										? <div style={{ textAlign: 'center', padding: 40, color: '#aaa' }}>Belum ada API Key</div>
										: dataSource.map(row => this.renderMobileCard(row))
								}
								{pagination.total > 0 && (
									<div style={{ textAlign: 'center', padding: '12px 0 4px' }}>
										<Pagination
											current={pagination.current} pageSize={pagination.pageSize}
											total={pagination.total} onChange={this.handleMobilePageChange}
											showSizeChanger={false} simple
										/>
									</div>
								)}
							</div>
						) : (
							<Table
								columns={this._buildColumns()}
								dataSource={dataSource}
								loading={loadingData}
								rowKey="id"
								scroll={{ x: 'max-content' }}
								size="middle"
								pagination={{
									current        : pagination.current,
									pageSize       : pagination.pageSize,
									total          : pagination.total,
									showSizeChanger: true,
									pageSizeOptions: ['10', '25', '50', '100'],
									showTotal      : (total, range) => `${range[0]}-${range[1]} dari ${total} data`,
								}}
								onChange={this.handleTableChange}
							/>
						)}
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => state.configReducers;

export default connect(mapStateToProps, {
	initHandler, setConfig, ajaxViewHandler, ajaxHandler,
})(DataApiKey);
